document.addEventListener("DOMContentLoaded", function () {
    let container = document.getElementById("recently-viewed-products");
    let section = document.querySelector(".recently-viewed-section");
    let viewedProducts = JSON.parse(localStorage.getItem("recentlyViewed")) || [];

    if (viewedProducts.length === 0) {
      section.style.display = "none"; // Hide section if no products
      return;
    }

    section.style.display = "block"; // Show section if products exist

    let html = '<div class="recently-viewed-products">';
    viewedProducts.forEach(product => {
      html += `
        <div class="product-card">
          <a href="${product.url}">
            <img src="${product.image}" alt="${product.title}">
            <div class="details">
              <div class="product-vendor">${product.vendor}</div>
              <div class="product-name">${product.title}</div>
              <div class="product-price">${product.price}</div>
            </div>
          </a>
        </div>
      `;
    });
    html += "</div>";
    container.innerHTML = html;
  });